import { ChangeDetectionStrategy, Component, EventEmitter, Input, model, ModelSignal, OnInit, Output, signal, WritableSignal } from '@angular/core';
import { Incident, IncidentsService, TagRequest } from 'src/app/api/incidents.service';
import { LinkableTagService, Tag } from 'src/app/api/linkable-tag.service';
import { switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AutoCompleteCompleteEvent, AutoCompleteSelectEvent } from 'primeng/autocomplete';

@Component({
    selector: 'app-tag-display',
    templateUrl: './tag-display.component.html',
    styleUrls: ['./tag-display.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagDisplayComponent implements OnInit {

  private readonly createNewTag = "(create new tag)"

  constructor(
    private incidentService: IncidentsService,
    private tagService: LinkableTagService
  ) {
    this._incident = incidentService.emptyIncident;
  }

  private _incident: Incident

  networkActive = signal(false);

  @Input() set incident(value: Incident) {
    this._incident = value;
    this.loadTags();
  }

  @Input() editMode = false;

  get incident(): Incident {
    return this._incident;
  }

  @Output() tagChanged: EventEmitter<void> = new EventEmitter<void>()

  removeActive = signal(false);
  availableTags: WritableSignal<Tag[]> = signal<Tag[]>([])
  availableTagNames: WritableSignal<string[]> = signal([])
  newTag: ModelSignal<string>  = model("");
  suggestions: WritableSignal<string[]> = signal([])
  addingTag = signal(false);

  ngOnInit(): void {
   
  }

  loadTags() {
    this.tagService.getTags().subscribe(tags => {
      this.availableTags.set( tags.filter(tag => {
        return this.incident.tags.find(t => t.id === tag.id) === undefined
      }))

      this.availableTagNames.set( this.availableTags().map(tag => tag.name).sort())
    })
  }

  onRemoveToggle() {
    this.removeActive.update(value => !value);
  }

  removeTag(tag: Tag) {
 
    this.networkActive.set(true);
    this.incidentService.unlinkTag(this.incident.workItemId, tag.id).subscribe(()=> {
      this.tagService.expireCache();
      this.tagChanged.emit();
      this.networkActive.set( false);
    })
  }

  addTag() {
    this.addingTag.set(true);
  }

  search(event: AutoCompleteCompleteEvent) {
    let returnArray = this.availableTagNames().filter(tag => tag.match(new RegExp(event.query, "i")))

    if (event.query && !returnArray.find(tag => tag.toLowerCase() === event.query.toLowerCase())) {
      returnArray = [event.query + " " +  this.createNewTag, ...returnArray]
    }
    
    this.suggestions.set(returnArray)
  
  }

  tagSelected(event: AutoCompleteSelectEvent) {
    let selectedTag = this.newTag();
   
    if (this.newTag().match(new RegExp(this.createNewTag, "i"))) {
      selectedTag = this.newTag().replace(this.createNewTag, "").trim()
      
    }

    selectedTag = selectedTag.toLowerCase();

    const tag = this.availableTags().find(t => t.name.toLowerCase() === selectedTag)

    let tagRequest: TagRequest
    if (tag) {
      tagRequest = {
        tagId: tag.id
      }
    } else {
      tagRequest = {
        newName: selectedTag
      }
    }
    
    this.networkActive.set(true);
    this.incidentService.linkTag(this.incident.workItemId, tagRequest).subscribe((tag)=> {
      this.incident.tags.push(tag)  
      this.tagService.expireCache();
      this.tagChanged.emit();
        this.addingTag.set(false);
        this.newTag.set("");
        this.networkActive.set(false);
    })
  }

}
